import { Package } from 'lucide-react';
import type { ModuleDefinition } from '../../core/shared/types/index.js';

const catalogusManifest: ModuleDefinition = {
  id: 'catalogus',
  name: 'Catalogus',
  icon: <Package size={20} />,
  color: '#7C5CBF',
  basePath: '/catalogus',
  status: 'active',
  navItems: [
    { label: 'Catalogus', path: '/catalogus', icon: '📦' },
  ],
  component: () => import('./index.js'),
};

export default catalogusManifest;
